import { WSList, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { useUserId } from "../../../../query/hooks/helpers";
import { useQueryPayerRows } from "../../../../query/search/payer/queries/useQueryPayerRows";
import {
  useMemberProfile,
  useUserProfile
} from "../../../../query/users/queries";
import { verificationService } from "../../../../shared/services/verificaiton";
import { CardTaxVerificationRequirementRequester } from "../../components/CardTaxVerificationRequirementRequester";
import { FormBusinessInformation } from "../../components/FormBusinessInformation";
import { getProfileDataBusiness } from "../../components/FormBusinessInformation/getProfileDataBusiness";
import { useOnboardignModules, useOnboardingContext } from "../../Context";
import { useMissingFields } from "../../hooks/useMissingFields";
import { OnboardingModuleCreateAccount, OnboardingStep } from "../../types";
import { CreateAccountContext } from "./types";
import { useRedirectToAccountType } from "./useRedirectToAccountType";

export const BusinessInformation: React.FC<OnboardingStep> = ({
  onNext,
  onBack
}) => {
  const [context, setContext] = useOnboardingContext<CreateAccountContext>();

  const modules = useOnboardignModules();
  const onboardingModule = modules.find(m => m.type === "create_account") as
    | OnboardingModuleCreateAccount
    | undefined;
  const show1099Message = onboardingModule?.options?.show1099Message;
  const verificationLevel =
    onboardingModule?.options?.verificationLevel || "Tax";

  const userId = useUserId();
  const queryUser = useUserProfile(userId);
  const queryMember = useMemberProfile(userId);
  const profileData = useMemo(
    () => getProfileDataBusiness(queryMember.data),
    [queryMember.data]
  );

  const missingFields = useMissingFields(verificationLevel);
  const isMismatch = useMemo(
    () => verificationService.getIsBusinessMismatch(missingFields),
    [missingFields]
  );

  const queryPayers = useQueryPayerRows();
  const payerCompanyName = useMemo(() => {
    const payer = queryPayers.data?.[0];

    if (!payer) {
      return undefined;
    }

    return {
      doingBusinessAs: payer.member?.profile?.company?.doingBusinessAs,
      legalBusinessName: payer.member?.profile?.company?.legalBusinessName
    };
  }, [queryPayers.data]);

  useRedirectToAccountType();

  return (
    <WSList gap="2XL">
      <CardTaxVerificationRequirementRequester />

      <FormBusinessInformation
        country={context.accountType?.country || "US"}
        defaultValues={context.businessInformation || profileData}
        onBack={onBack}
        onSubmit={data => {
          setContext(prev => ({ ...prev, businessInformation: data }));
          onNext?.();
        }}
        show1099Message={show1099Message}
        personalEmail={queryUser.data?.email}
        mismatch={isMismatch}
        payerCompanyName={payerCompanyName}
      />

      <WSText.ParagraphXs color="gray400">
        The information on this page is required to setup your Wingspan account,
        if you exit or leave without completing this step, you will return to
        this page the next time you sign-in
      </WSText.ParagraphXs>
    </WSList>
  );
};
